import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable, Subject } from 'rxjs';

@Injectable()
export class MatdialogService {

	private matdialog$ = new Subject<boolean>();
	dialogRef: MatDialogRef<{}, any> = null;

	constructor(private dialog: MatDialog) {
		this.matdialog$.next(false);
	}

	get() {
		return this.matdialog$;
	}

	set(dialog: boolean) {
		if (dialog == false) {
			this.closeDialog();
		}
		this.matdialog$.next(dialog);
	}

	openAfterClosed(modal: any, info: any, c?: any): Observable<any> {
		this.dialogRef = this.dialog.open(modal, info);
		this.matdialog$.next(true);
		return this.dialogRef.afterClosed();
	}

	openBeforeClosed(modal: any, info: any, c?: any): Observable<any> {
		this.dialogRef = this.dialog.open(modal, info);
		this.matdialog$.next(true);
		return this.dialogRef.beforeClosed();
	}

	closeDialog() {
		if (this.dialogRef != null && typeof (this.dialogRef) !== 'undefined') {
			this.dialogRef.close();
			this.matdialog$.next(false);
			this.dialogRef = null;
		}
	}

}
